import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { floors } from './floorData';
export function FloorsSection() {
  const [activeId, setActiveId] = useState(floors[0].id);
  const active = floors.find(f => f.id === activeId) ?? floors[0];
  return <section className="w-full py-14 md:py-32 bg-bg-light relative z-10" data-id="element-65" data-mp="1axsou895j5ir">
      <div className="px-6 md:px-14" data-id="element-66" data-mp="1azx4fngexsyv">
        <div className="max-w-7xl mx-auto" data-id="element-67" data-mp="n7q0a24g4how">
          {/* Header + tabs */}
          <header className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8 md:mb-12" data-id="element-68" data-mp="i950g3t3w00z">
            <div data-id="element-69" data-mp="w8o8kwlx3bda">
              <p className="text-xs tracking-widest text-text-muted font-light mb-3 uppercase" data-id="element-70" data-mp="w96c8eawsrv8">
                Floor Areas
              </p>
              <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight text-primary leading-tight" data-id="element-71" data-mp="r8icn48m72pe">
                Explore each level
              </h2>
            </div>

            {/* Tabs */}
            <div role="tablist" aria-label="Select a floor" className="flex items-center gap-6 md:gap-8" data-id="element-72" data-mp="22rcob9ql51le">
              {floors.map(floor => <button key={floor.id} role="tab" aria-selected={activeId === floor.id} onClick={() => setActiveId(floor.id)} className="group/tab relative pb-2 text-base md:text-lg font-light transition-colors" data-id="element-73" data-mp="3uy5bwqth1nbh">
                  <span className={activeId === floor.id ? 'text-primary' : 'text-text-muted'} data-id="element-74" data-mp="3c5jgg7mh7yrf">
                    {floor.tab}
                  </span>
                  <span className={`absolute left-0 -bottom-px h-px bg-accent transition-all duration-500 ease-out ${activeId === floor.id ? 'w-full' : 'w-0 group-hover/tab:w-1/2'}`} data-id="element-75" data-mp="3lwe3vfbgl4eg" />
                </button>)}
            </div>
          </header>

          {/* Plan image + inline breakdown */}
          <AnimatePresence mode="wait" data-id="element-76" data-mp="2hd0hfxxnu86q">
            <motion.div key={active.id} initial={{
            opacity: 0,
            y: 24
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -12
          }} transition={{
            duration: 0.6,
            ease: [0.16, 1, 0.3, 1]
          }} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start" data-id="element-77" data-mp="2hbz6dtgn9lp0">
              {/* Plan image */}
              <div className="lg:col-span-7" data-id="element-78" data-mp="27eb66o09rlzg">
                <img src={active.planImage} alt={`${active.planLabel} — labeled layout of ${active.title}`} className="w-full h-auto object-contain" data-id="element-79" data-mp="27djdbky242cv" />
              </div>

              {/* Breakdown */}
              <div className="lg:col-span-5" data-id="element-80" data-mp="14lgvfnqzzoob">
                {/* Compact total + ceiling */}
                <div className="flex items-baseline justify-between gap-6 pb-5 border-b border-black/10" data-id="element-81" data-mp="19me9pp8vzykj">
                  <div data-id="element-82" data-mp="vmvf7z900lqp">
                    <h3 className="font-heading text-xl md:text-2xl font-light tracking-tight text-primary leading-tight" data-id="element-83" data-mp="vnn12icsn53s">
                      {active.title}
                    </h3>
                    <p className="mt-1 text-2xl md:text-3xl font-light text-accent tracking-tight leading-none" data-id="element-84" data-mp="1oar9yyf0c3ku">
                      {active.area}
                    </p>
                  </div>
                  <div className="text-right shrink-0" data-id="element-85" data-mp="1ejwnbsxun1yv">
                    <p className="text-[0.7rem] tracking-widest text-text-muted font-light uppercase" data-id="element-86" data-mp="1jizhgicajns2">
                      Ceiling
                    </p>
                    <p className="mt-1 text-lg md:text-xl font-light text-primary" data-id="element-87" data-mp="277se6h0qlznq">
                      {active.ceilingHeight}
                    </p>
                  </div>
                </div>

                {/* Room rows */}
                <dl className="mt-5 space-y-0" data-id="element-88" data-mp="if60sp7zdvbp">
                  {active.rows.map(row => <div key={row.label} className="flex items-baseline justify-between gap-6 border-b border-black/5 py-2.5" data-id="element-89" data-mp="ed18pux6l6r6">
                      <dt className="tracking-wide text-sm font-light text-text-muted leading-snug" data-id="element-90" data-mp="164h3ic8w5zsh">
                        {row.label}
                      </dt>
                      <dd className="whitespace-nowrap text-sm font-light text-primary" data-id="element-91" data-mp="123f0rlfrn5lr">
                        {row.value}
                      </dd>
                    </div>)}
                </dl>

                {active.footnote && <p className="mt-5 text-xs tracking-wide font-light text-text-muted" data-id="element-92" data-mp="1pszki6jqu6w3">
                    {active.footnote}
                  </p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
}